import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { AppBar, Button, Toolbar, Hidden } from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import { logout } from "../../logout";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "none",
  },
  flexGrow: {
    flexGrow: 1,
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  header: {
    textDecoration: "none",
    fontFamily: "Roboto",
    color: "white",
    fontSize: "26px",
    letterSpacing: "1px",
  },
}));

function TopBar({ className }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const currentType = useSelector(
    (state) => state.currentTypeState.currentType
  );

  const handleRouteRedirect = () => {
    if (currentType === "DEVICES") {
      return "/main/devices/Information";
    } else {
      return "/main/assemblies/Information";
    }
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <AppBar className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <RouterLink to={handleRouteRedirect}>
          <h2 className={classes.header}>Manufacturing Tool Dashboard</h2>
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden lgDown>
          <Button
            className={classes.logoutButton}
            color="inherit"
            onClick={handleLogout}
          >
            <InputIcon className={classes.logoutIcon} />
            Sign out
          </Button>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
